import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold text-lg mb-4">About Talent Link</h3>
            <p className="text-gray-400">
              Connecting Talent. Empowering Futures. We champion ethical recruitment, sustainable development, and inclusive economic growth across Africa.
            </p>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="/" className="hover:text-white">Home</a></li>
              <li><a href="/about" className="hover:text-white">About Us</a></li>
              <li><a href="/jobs" className="hover:text-white">Browse Jobs</a></li>
              <li><a href="/faqs" className="hover:text-white">FAQs</a></li>
              <li><a href="/education" className="hover:text-white">Resources</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Our Sectors</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Mining</li>
              <li>Agriculture</li>
              <li>Energy</li>
              <li>Construction</li>
              <li>Industrial</li>
              <li>Professional Services</li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Contact Us</h3>
            <div className="space-y-2 text-gray-400 text-sm">
              <div className="flex items-center space-x-2">
                <Mail size={18} />
                <a href="mailto:info@talentlinkemploymentagency.com" className="hover:text-white">info@talentlinkemploymentagency.com</a>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={18} />
                <a href="tel:+263772155436" className="hover:text-white">+263 77 215 5436</a>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin size={18} />
                <span>Harare, Zimbabwe</span>
              </div>
              <div className="flex space-x-3 mt-4">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-blue-400"><Facebook size={20} /></a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="hover:text-blue-400"><Twitter size={20} /></a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="hover:text-blue-400"><Linkedin size={20} /></a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2026 Talent Link Employment Agency. All rights reserved.</p>
          <p className="text-sm mt-2 italic">Connecting Talent. Empowering Futures.</p>
        </div>
      </div>
    </footer>
  );
}
